
import React from "react";
import {useAppSelector} from "../DAL/store";
import { LocalEnums } from "../local-enums";
import ProductPriceFormat from "../../products/product-price/product-price-format";


/**
 * Chosen product for desktop's right sticky view
 */

const ChosenProducts = () => {

    const UserState_SelectedProducts = useAppSelector((store) => store.UserState_SelectedProducts);
    const CategoryList = useAppSelector((store) => store.CategoryList);
    const ImageCDNDomain = useAppSelector((store) => store.ImageCDNDomain);
    const UserState_CableCount= useAppSelector((store) => store.UserState_CableCount);

    return (
        <div className="overflow-auto" style={{maxHeight:"50vh"}}>
            {CategoryList.map(category => {
                return UserState_SelectedProducts.filter(prod => prod.categoryID === category.categoryID)
                    .map((product,index,items) => {
                        return  <div className={items.length -1 === index ? "border-b" : ""} key={product.skuid}>
                                    {index === 0 && <div className="font-bold w-full pt-3">{product.categoryDisplayName}</div>}
                                    <div className="flex items-center" key={product.skuid}>
                                        <div className="w-1/4 p-2 pl-0">
                                            <img  src={ImageCDNDomain +product.thumb}
                                                  title={product.skuName}
                                                  alt={product.skuName} />
                                        </div>
                                        <div className="w-1/2">
                                            <div className="w-full pt-1 text-sm">{product.skuName}</div>
                                        </div>
                                        <div className="w-1/6 text-center my-2">
                                            {product.categoryProductID === LocalEnums.ProductsIds.Cable ?
                                                <div className="m-1 bg-gray-150 rounded">Qt:{UserState_CableCount}</div>
                                                :
                                                <div className="m-1 bg-gray-150 rounded">Qt:{product.quantity > 0 ? product.quantity : 1}</div>
                                            }
                                        </div>
                                        <div className="w-1/6 text-right font-bold pr-0.5">
                                            <ProductPriceFormat price={ product.skuPrice } />
                                        </div>
                                    </div>
                                </div>;
                    });
            })}
        </div>
    );
};

export default ChosenProducts;
